'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { HTTPError } from '@qogita/deprecated-canary-client'
import {
  keepPreviousData,
  QueryCache,
  QueryClient,
  QueryClientProvider as TanstackQueryClientProvider,
} from '@tanstack/react-query'
import { ReactNode, useState } from 'react'

export function QueryClientProvider({ children }: { children: ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            throwOnError: true,

            placeholderData: keepPreviousData,
            retry: (failureCount, error) => {
              // There's no point retrying if the error is a 404 or 401, or we're rate limited (429)
              if (
                error instanceof HTTPError &&
                [404, 401, 429].includes(error.response.status)
              ) {
                return false
              }

              // Otherwise retry up to 3 times
              return failureCount < 3
            },
          },
        },
        queryCache: new QueryCache({
          onError: (error) => {
            if (error instanceof HTTPError && error.response.status === 401) {
              // If we get a 401 we probably have an expired session, so hard reload the page to trigger a middleware re-run
              // which will either refresh the session or log the user out
              window.location.reload()
            }
          },
        }),
      }),
  )
  return (
    <TanstackQueryClientProvider client={queryClient}>
      {children}
    </TanstackQueryClientProvider>
  )
}
